import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../api.js";
import Swal from "sweetalert2";
import Menu from "../../components/Menu.js";
import "../componentCss/ReportRevenueDistribuitionAdd.css";
import Modal from "react-bootstrap/Modal";
import {
  Form,
  Button,
  Card,
  Container,
  Row,
  Col,
  ListGroup,
  Badge,
  Spinner,
} from "react-bootstrap";

const ConsultTransfer = () => {
  // Estado para as datas
  const [dataInicio, setDataInicio] = useState("");
  const navigate = useNavigate();
  const [dataFim, setDataFim] = useState("");
  const [dataRepasse, setDataRepasse] = useState(null);
  const [recibo, setRecibo] = useState(null);

  //const [dataFilters, setDataFilters] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const [description, setDescription] = useState("");

  const [filtroEmpresa, setFiltroEmpresa] = useState("");
  const [filtroEmpresas, setFiltroEmpresas] = useState([]);

  // State para os dados do formulário
  const [formData, setFormData] = useState({
    nome: "",
    email: "",
    telefone: "",
  });

  // Estado para o modal
  // Função para enviar o formulário
  const handleSubmit = (e) => {
    e.preventDefault();
    // Aqui você pode adicionar a lógica para salvar os dados
    console.log("Dados enviados:", formData);

    // Limpar o formulário e fechar o modal
    setFormData({
      nome: "",
      email: "",
      telefone: "",
    });
    handleCloseModal();
  };

  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData({
  //     ...formData,
  //     [name]: value,
  //   });
  // };

  // Estado para a lista de médicos
  const [todosMedicos, setTodosMedicos] = useState([]);
  /*   {
      id: 1,
      nome: "Dra. Ana Silva",
      especialidade: "Cardiologia",
      selecionado: false,
      avatar: "AS",
    },
    {
      id: 2,
      nome: "Dr. Carlos Oliveira",
      especialidade: "Neurologia",
      selecionado: false,
      avatar: "CO",
    },
    {
      id: 3,
      nome: "Dra. Mariana Costa",
      especialidade: "Dermatologia",
      selecionado: false,
      avatar: "MC",
    },
    {
      id: 4,
      nome: "Dr. Roberto Santos",
      especialidade: "Ortopedia",
      selecionado: false,
      avatar: "RS",
    },
    {
      id: 5,
      nome: "Dra. Juliana Lima",
      especialidade: "Pediatria",
      selecionado: false,
      avatar: "JL",
    },
    {
      id: 6,
      nome: "Dr. Felipe Souza",
      especialidade: "Oftalmologia",
      selecionado: false,
      avatar: "FS",
    },
    {
      id: 7,
      nome: "Dra. Camila Martins",
      especialidade: "Ginecologia",
      selecionado: false,
      avatar: "CM",
    },
    {
      id: 8,
      nome: "Dr. Eduardo Pereira",
      especialidade: "Urologia",
      selecionado: false,
      avatar: "EP",
    },

    {
      id: 9,
      nome: "Dr. Felipe Souza",
      especialidade: "Oftalmologia",
      selecionado: false,
      avatar: "FS",
    },
    {
      id: 10,
      nome: "Dra. Camila Martins",
      especialidade: "Ginecologia",
      selecionado: false,
      avatar: "CM",
    },
    {
      id: 11,
      nome: "Dr. Eduardo Pereira",
      especialidade: "Urologia",
      selecionado: false,
      avatar: "EP",
    }, */

  //criar um modal
  const [showModal, setShowModal] = useState(false);
  const handleCloseModal = () => setShowModal(false);
  const handleShowModal = () => setShowModal(true);

  // Estado para médicos filtrados
  const [medicosFiltrados, setMedicosFiltrados] = useState([]);

  // Estado para controlar a pesquisa
  const [pesquisaRealizada, setPesquisaRealizada] = useState(false);
  const [carregando, setCarregando] = useState(false);
  const [erroData, setErroData] = useState("");
  const [medicosSelecionados, setMedicosSelecionados] = useState([]);
  const [emergency, setEmergency] = useState("false");
  const medicosDisponiveis = medicosFiltrados.filter(
    (medico) => !medico.fund_executing_id
  );

  useEffect(() => {
    const listaSegura = Array.isArray(todosMedicos) ? todosMedicos : [];

    if (listaSegura.length > 0 && filtroEmpresa !== "") {
      setFiltroEmpresas(
        Array.from(
          new Set(
            listaSegura
              .filter(
                (medico) =>
                  medico &&
                  (typeof medico.fund_executing_id === "undefined" ||
                    medico.fund_executing_id == null)
              )
              .map((medico) => medico.executing_company)
          )
        )
      );

      setMedicosFiltrados(
        listaSegura.filter(
          (medico) => medico && medico.executing_company === filtroEmpresa
        )
      );
    } else {
      setFiltroEmpresas(
        Array.from(
          new Set(
            listaSegura
              .filter(
                (medico) =>
                  medico &&
                  (typeof medico.fund_executing_id === "undefined" ||
                    medico.fund_executing_id == null)
              )
              .map((medico) => medico.executing_company)
          )
        )
      );

      setMedicosFiltrados(
        listaSegura.filter(
          (medico) =>
            medico &&
            (typeof medico.fund_executing_id === "undefined" ||
              medico.fund_executing_id == null)
        )
      );
    }

    console.log("Dados do Médicos Filtrados: ", medicosFiltrados);
  }, [filtroEmpresa, todosMedicos]);

  // useEffect(() => {
  //   console.log("Dados do Filtro: ", dataFilters);
  //   console.log("Dados do Médicos: ", todosMedicos);
  //   console.log("Dados do Médicos Filtrados: ", medicosFiltrados);
  // }, [dataFilters, todosMedicos, medicosFiltrados, medicosSelecionados]);
  
  useEffect(() => {
    setMedicosFiltrados(todosMedicos);
  }, [todosMedicos]);

  useEffect(() => {
    setTotalAmount(
      medicosSelecionados.reduce((total, medico) => {
        return total + (Number(medico.procedure_value) || 0);
      }, 0)
    );
  }, [medicosSelecionados]);

  //selecionados
  useEffect(() => {
    console.log("Dados do Médicos Selecionados: ", medicosSelecionados);
  }, [medicosSelecionados]);
  const handleFileChange = (event) => {
    const file = event.target.files[0]; // Pega o primeiro arquivo selecionado
    if (file) {
      const allowedTypes = ["image/jpeg", "image/png", "application/pdf"];
      if (!allowedTypes.includes(file.type)) {
        setErroData(
          "Por favor, selecione um arquivo de imagem (jpg, jpeg, png) ou PDF"
        );
        setRecibo(null);
        return;
      }
      setErroData("");
      setRecibo(file);
    }
  };
  useEffect(() => {
    console.log("Filtro por médico: ", filtroEmpresa);
  }, [filtroEmpresa]);

  const toggleFiltrarMedico = (empresa) => {
    //filtrar so os da empresa
    const medicosFiltrados = todosMedicos.filter(
      (medico) => medico.executing_company === empresa
    );

    setMedicosFiltrados(medicosFiltrados);
    setFiltroEmpresa(empresa);
  };

  // const handleFiltroEmpresa = (empresa) => {
  //   setFiltroEmpresa(empresa);
  //   toggleFiltrarMedico(empresa);
  // };

  // Cores para as especialidades
  const coresEspecialidades = {
    Cardiologia: "danger",
    Neurologia: "info",
    Dermatologia: "success",
    Ortopedia: "warning",
    Pediatria: "primary",
    Oftalmologia: "secondary",
    Ginecologia: "dark",
    Urologia: "info",
  };

  // Efeito para atualizar médicos selecionados quando mudam os filtrados
  useEffect(() => {
    setMedicosSelecionados(
      medicosFiltrados.filter((medico) => medico.selecionado)
    );
  }, [medicosFiltrados]);

  // Função para selecionar/deselecionar um médico
  const toggleSelecionarMedico = (id) => {
    setMedicosFiltrados(
      medicosFiltrados.map((medico) =>
        medico.id === id
          ? { ...medico, selecionado: !medico.selecionado }
          : medico
      )
    );
  };

  useEffect(() => {
    console.log("Recibo: ", recibo);
  }, [recibo]);

  // Função para selecionar/deselecionar todos os médicos
  const toggleSelecionarTodos = () => {
    const todosEstaoSelecionados = (medicosFiltrados || []).every(
      (medico) => medico.selecionado && !medico.fund_executing_id
    );
    setMedicosFiltrados(
      medicosFiltrados.map((medico) => ({
        ...medico,
        selecionado: !todosEstaoSelecionados && !medico.fund_executing_id,
      }))
    );
  };

  // Função para validar as datas
  const validarDatas = () => {
    if (!dataInicio || !dataFim) {
      setErroData("Selecione as datas inicial e final");
      return false;
    }

    const inicio = new Date(dataInicio);
    const fim = new Date(dataFim);

    if (fim < inicio) {
      setErroData("A data final deve ser maior ou igual à data inicial");
      return false;
    }

    setErroData("");
    return true;
  };

  // Função para filtrar médicos
  const filtrarMedicos = async (e) => {
    e.preventDefault();

    if (!validarDatas()) return;

    setCarregando(true);

    try {
      // Aqui você substituiria por chamadas reais à API
      const filters = {
        date_init: dataInicio,
        date_end: dataFim,
        is_appointment: true,
        emergency_attendance: emergency === "true",
        payment_method: null,
        customer_id: null,
        user_id: null,
        transaction_type: null,
        procedure_value1: null,
        procedure_value2: null,
        procedure_value3: null,
        requesting_company: null,
        executing_company: null,
        customer_name: null,
        procedure_name: null,
        user_name: null,
      };

      // Remover filtros nulos para evitar poluição da requisição
      const cleanedFilters = Object.fromEntries(
        Object.entries(filters).filter(([_, v]) => v != null)
      );

      console.log("Filtros enviados:", cleanedFilters);

      const response = await api.post("api/report/cashboxs", cleanedFilters);
      const lista = Array.isArray(response.data) ? response.data : [];
      setTodosMedicos(lista);
      setMedicosFiltrados(
        [...todosMedicos].map((medico) => ({ ...medico, selecionado: false }))
      );
      setPesquisaRealizada(true);
      Swal.fire({
        icon: "success",
        title: "Médicos filtrados com sucesso!",
        showConfirmButton: false,
        timer: 1500,
      });
    } catch (error) {
      console.error("Erro ao buscar médicos:", error);
      Swal.fire({
        icon: "error",
        title: "Erro ao buscar médicos",
        text: "Ocorreu um erro ao buscar médicos. Por favor, tente novamente.",
        showConfirmButton: false,
        timer: 1500,
      });
    } finally {
      setCarregando(false);
    }

    // Simular um tempo de carregamento para demonstração
    /*
    setTimeout(() => {
      // Em uma aplicação real, você faria uma chamada à API aqui
      // Por enquanto, estamos apenas usando a lista de médicos já existente
      setMedicosFiltrados(
        [...todosMedicos].map((medico) => ({ ...medico, selecionado: false }))
      );
      setPesquisaRealizada(true);
      setCarregando(false);
    }, 800);
   */
  };

  const confirmarSelecao = async () => {
    if (!validarDatas()) return;

    if (!description) {
      Swal.fire({
        icon: "warning",
        title: "Atenção!",
        text: "Você precisa digitar uma descrição para o repasse.",
        showConfirmButton: true,
      });
      return;
    }

    setCarregando(true);

    try {
      const formData = new FormData();
      formData.append("start_date", dataInicio);
      formData.append("end_date", dataFim);
      formData.append("type", emergency === "true" ? "PA" : "C");
      formData.append("total_amount", totalAmount || 0);
      formData.append("transfer_month", dataRepasse);
      formData.append("description", description.toLocaleUpperCase());
      formData.append("photo", recibo);
      medicosSelecionados.forEach((m) => {
        formData.append("cashboxs[]", m.id);
      });

      /*if (recibo instanceof File) {
        formData.append("photo", recibo);
      } else {
        console.error("Erro: recibo não é um arquivo válido.");
        return;
      } */

      console.log("Enviando FormData:", formData);

      const response = await api.post("api/fund-transfers", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      Swal.fire({
        icon: "success",
        title: "Repasse registrado com sucesso!",
        showConfirmButton: false,
        timer: 1500,
      });
      navigate("/financial/revenue-distribution-consult-emergency");
      console.log(response.data);
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Erro ao Registrar o Repasse",
        text: "Ocorreu um erro ao registrar o repasse. Por favor, tente novamente.",
        showConfirmButton: false,
        timer: 1500,
      });
      console.error("Erro ao Registrar o Repasse!", error);
    } finally {
      setCarregando(false);
    }
  };

  // Limpar filtros
  const limparFiltros = () => {
    setDataInicio("");
    setDataFim("");
    setMedicosFiltrados([]);
    setPesquisaRealizada(false);
    setErroData("");
  };

  // Função para formatar o valor
  const formatCurrency = (value) => {
    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(value || 0);
  };

  // Gerar uma cor para os avatares
  // const gerarCorAvatar = (id) => {
  //   const cores = [
  //     "#3498db",
  //     "#2ecc71",
  //     "#e74c3c",
  //     "#f39c12",
  //     "#9b59b6",
  //     "#1abc9c",
  //     "#d35400",
  //     "#34495e",
  //   ];
  //   return cores[id % cores.length];
  // };

  const screenTela = (
    <Container
      fluid
      className="py-4 px-md-4"
      style={{ backgroundColor: "#f8f9fa", minHeight: "90vh" }}>
      <Row className="justify-content-center">
        <Col xs={12} lg={10} xl={9}>
          <div className="text-right mb-5">
            <h2 className="display-6 fw-bold text-black">Repasse de Receita</h2>
          </div>
          <Card className="mb-4 shadow-sm border-0 rounded-3">
            <Card.Header className="text-black py-3">
              <h5 className="mb-0">
                <i className="bi bi-funnel-fill me-2"></i>Filtros de Pesquisa
              </h5>
            </Card.Header>
            <Card.Body className="p-4">
              <Form onSubmit={filtrarMedicos}>
                {/* Primeira linha - 3 colunas */}
                <Row className="mb-4 g-3">
                  <Col xs={12} sm={4}>
                    <Form.Group controlId="dataInicio">
                      <Form.Label className="fw-bold">
                        Data de Início
                      </Form.Label>
                      <Form.Control
                        type="date"
                        value={dataInicio}
                        onChange={(e) => setDataInicio(e.target.value)}
                        required
                        className="rounded-3"
                        isInvalid={!!erroData}
                      />
                      {erroData && (
                        <Form.Control.Feedback type="invalid">
                          {erroData}
                        </Form.Control.Feedback>
                      )}
                    </Form.Group>
                  </Col>
                  <Col xs={12} sm={4}>
                    <Form.Group controlId="dataFim">
                      <Form.Label className="fw-bold">Data de Fim</Form.Label>
                      <Form.Control
                        type="date"
                        value={dataFim}
                        onChange={(e) => setDataFim(e.target.value)}
                        required
                        className="rounded-3"
                        isInvalid={!!erroData}
                      />
                      {erroData && (
                        <Form.Control.Feedback type="invalid">
                          {erroData}
                        </Form.Control.Feedback>
                      )}
                    </Form.Group>
                  </Col>

                  <Col xs={12} sm={4}>
                    <Form.Group controlId="dataRepasse">
                      <Form.Label className="fw-bold">
                        Mês de Repasse
                      </Form.Label>
                      <Form.Control
                        type="month"
                        value={dataRepasse}
                        onChange={(e) => setDataRepasse(e.target.value)}
                        className="rounded-3"
                        isInvalid={!!erroData}
                      />
                      {erroData && (
                        <Form.Control.Feedback type="invalid">
                          {erroData}
                        </Form.Control.Feedback>
                      )}
                    </Form.Group>
                  </Col>
                </Row>

                {/* Segunda linha - 3 colunas com descrição ocupando mais espaço */}
                <Row className="mb-4 g-3">
                  <Col xs={12} sm={3}>
                    <Form.Group controlId="recibo">
                      <Form.Label className="fw-bold">
                        Anexo de Recibo
                      </Form.Label>
                      <Form.Control
                        type="file"
                        accept=".jpg,.jpeg,.png,.pdf"
                        onChange={handleFileChange}
                        className="rounded-3"
                        isInvalid={!!erroData}
                      />
                      {erroData && (
                        <Form.Control.Feedback type="invalid">
                          {erroData}
                        </Form.Control.Feedback>
                      )}
                    </Form.Group>
                  </Col>

                  <Col xs={12} sm={6}>
                    <Form.Group controlId="description">
                      <Form.Label className="fw-bold">Descrição</Form.Label>
                      <Form.Control
                        type="text"
                        value={description}
                        onChange={(e) =>
                          setDescription(e.target.value.toLocaleUpperCase())
                        }
                        className="rounded-3"
                        isInvalid={!!erroData}
                      />
                      {erroData && (
                        <Form.Control.Feedback type="invalid">
                          {erroData}
                        </Form.Control.Feedback>
                      )}
                    </Form.Group>
                  </Col>
                  <Col xs={12} sm={3}>
                    <Form.Group controlId="description">
                      <Form.Label className="fw-bold">
                        Pronto Atendimento:
                      </Form.Label>
                      <Form.Select
                        value={emergency}
                        onChange={(e) => setEmergency(e.target.value)}
                        className="rounded-3"
                        isInvalid={!!erroData}>
                        <option value="true">Sim</option>
                        <option value="false">Não</option>
                      </Form.Select>
                      {erroData && (
                        <Form.Control.Feedback type="invalid">
                          {erroData}
                        </Form.Control.Feedback>
                      )}
                    </Form.Group>
                  </Col>
                </Row>

                {/* Botões de Ação */}
                <div className="d-grid gap-2 d-sm-flex justify-content-sm-end">
                  <Button
                    variant="outline-secondary"
                    onClick={limparFiltros}
                    className="rounded-pill px-4"
                    type="button">
                    <i className="bi bi-arrow-counterclockwise me-2"></i>
                    Limpar
                  </Button>
                  {/* Modal */}
                  <Modal
                    className="modal-container-repasse"
                    size="lg"
                    show={showModal}
                    onHide={handleCloseModal}
                    backdrop="static"
                    keyboard={false}
                    centered>
                    {/* Cabeçalho do Modal */}
                    <Modal.Header
                      closeButton
                      className="d-flex justify-content-between align-items-center">
                      <div>
                        <Modal.Title>
                          Selecione os médicos desejados
                        </Modal.Title>
                        <div className="d-flex justify-content-between align-items-center mb-3 gap-2">
                          <span className="text-muted">
                            Selecione os médicos desejados:
                          </span>

                          <Button
                            variant={
                              medicosFiltrados.every(
                                (medico) => medico.selecionado
                              )
                                ? "outline-danger"
                                : "outline-primary"
                            }
                            size="sm"
                            onClick={toggleSelecionarTodos}
                            className="rounded-pill px-3">
                            {medicosFiltrados.every(
                              (medico) => medico.selecionado
                            ) ? (
                              <>
                                <i className="bi bi-x-circle me-1"></i>
                                Desmarcar Todos
                              </>
                            ) : (
                              <>
                                <i className="bi bi-check-circle me-1"></i>
                                Selecionar Todos
                              </>
                            )}
                          </Button>
                        </div>
                      </div>
                    </Modal.Header>

                    {/* Corpo do Modal */}
                    <Modal.Body className="modal-body-repasse">
                      {medicosDisponiveis.length > 0 ? (
                        <section>
                          <div className="border rounded overflow-auto list-medical-v2">
                            <ListGroup
                              variant="flush"
                              className="list-medical-v2-all">
                              {(medicosFiltrados || [])
                                .filter(
                                  (medico) =>
                                    medico &&
                                    (typeof medico.fund_executing_id ===
                                      "undefined" ||
                                      medico.fund_executing_id == null)
                                )
                                .map((medico) => (
                                  <ListGroup.Item
                                    key={medico.id}
                                    className="d-flex justify-content-between align-items-center py-3 px-3"
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                    }}
                                    action
                                    onClick={() =>
                                      toggleSelecionarMedico(medico.id)
                                    }
                                    active={medico.selecionado}>
                                    <div className="d-flex align-items-center">
                                      <div>
                                        <div className="fw-bold">
                                          {medico.executing_company}
                                        </div>
                                        <div
                                          style={{
                                            fontSize: "14px",
                                            width: "30vw",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: "nowrap",
                                          }}
                                          title={medico.customer_name}>
                                          {medico.customer_name}
                                        </div>
                                        <Badge
                                          bg={
                                            coresEspecialidades[
                                              medico.especialidade
                                            ]
                                          }
                                          className="rounded-pill">
                                          {medico.especialidade}
                                        </Badge>
                                      </div>
                                    </div>
                                    <div className="d-flex align-items-center">
                                      <span>
                                        valor:{" "}
                                        {formatCurrency(medico.procedure_value)}
                                      </span>
                                    </div>
                                    <Form.Check
                                      type="checkbox"
                                      checked={medico.selecionado}
                                      onChange={() => {}}
                                      onClick={(e) => e.stopPropagation()}
                                      className="fs-5"
                                    />
                                  </ListGroup.Item>
                                ))}
                            </ListGroup>
                          </div>
                        </section>
                      ) : (
                        <div className="text-center p-4">
                          <i
                            className="bi bi-search"
                            style={{ fontSize: "3rem" }}></i>
                          <p className="lead mt-3 mb-0">
                            Nenhum médico encontrado para o período selecionado.
                          </p>
                        </div>
                      )}
                    </Modal.Body>

                    {/* Rodapé do Modal */}
                    <Modal.Footer>
                      <div className="mt-3 d-flex justify-content-between align-items-center flex-wrap gap-2">
                        <div>
                          <small className="text-muted">
                            {medicosSelecionados.length} de{" "}
                            {medicosFiltrados.length} médicos selecionados
                          </small>
                        </div>
                      </div>
                      <Button variant="secondary" onClick={handleCloseModal}>
                        Cancelar
                      </Button>
                      <Button variant="primary" onClick={handleSubmit}>
                        Salvar
                      </Button>
                    </Modal.Footer>
                  </Modal>
                  <Button
                    variant="primary"
                    type="submit"
                    className="rounded-pill px-4 shadow-sm"
                    disabled={carregando}>
                    {carregando ? (
                      <>
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                          className="me-2"
                        />
                        Buscando...
                      </>
                    ) : (
                      <>
                        <i className="bi bi-search me-2"></i>
                        Buscar Médicos
                      </>
                    )}
                  </Button>
                </div>
              </Form>
            </Card.Body>
          </Card>

          {pesquisaRealizada && (
            <Card className="shadow-sm border-0 rounded-3">
              <Card.Header className="text-black py-3">
                <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                  <h5 className="mb-0">
                    <i className="bi bi-list-check me-2"></i>
                    Médicos Disponíveis
                  </h5>
                  <Badge bg="light" text="dark" pill className="px-3 py-2">
                    {dataInicio} até {dataFim}
                  </Badge>
                </div>
              </Card.Header>
              <Card.Body className="p-3">
                {medicosDisponiveis.length > 0 ? (
                  <>
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <span className="text-muted">
                        Selecione os médicos desejados:
                      </span>
                      <Form.Select
                        style={{
                          borderRadius: "25px",
                          border: "1px solid #ccc",
                          padding: "5px 10px",
                          cursor: "pointer",
                          outline: "none",
                          color: "#333",
                          width: "200px",
                        }}
                        value={filtroEmpresa}
                        onChange={(e) => {
                          const valorSelecionado = e.target.value;
                          setFiltroEmpresa(valorSelecionado);
                          toggleFiltrarMedico(valorSelecionado);
                        }}>
                        <option value="">Selecione</option>
                        {(filtroEmpresas || [])
                          .filter(
                            (medico) =>
                              medico &&
                              (typeof medico.fund_executing_id ===
                                "undefined" ||
                                medico.fund_executing_id == null)
                          )
                          .map((empresa) => (
                            <option key={empresa} value={empresa}>
                              {empresa}
                            </option>
                          ))}
                      </Form.Select>
                      <div className="d-flex gap-2">
                        <Button
                          variant="outline-primary"
                          onClick={handleShowModal}
                          className="rounded-pill  shadow-sm">
                          <i className="bi bi-plus"></i>
                          Abrir
                        </Button>
                        <Button
                          variant={
                            medicosFiltrados.every(
                              (medico) => medico.selecionado
                            )
                              ? "outline-danger"
                              : "outline-primary"
                          }
                          size="sm"
                          onClick={toggleSelecionarTodos}
                          className="rounded-pill px-3">
                          {medicosFiltrados.every(
                            (medico) => medico.selecionado
                          ) ? (
                            <>
                              <i className="bi bi-x-circle me-1"></i>Desmarcar
                              Todos
                            </>
                          ) : (
                            <>
                              <i className="bi bi-check-circle me-1"></i>
                              Selecionar Todos
                            </>
                          )}
                        </Button>
                      </div>
                    </div>
                    <div className="border rounded overflow-auto list-medical">
                      <ListGroup variant="flush">
                        {(medicosFiltrados || [])
                          .filter(
                            (medico) =>
                              medico &&
                              (typeof medico.fund_executing_id ===
                                "undefined" ||
                                medico.fund_executing_id == null)
                          )
                          .map((medico) => (
                            <ListGroup.Item
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                              key={medico.id}
                              className="d-flex justify-content-between align-items-center py-3 px-3"
                              action
                              onClick={() => toggleSelecionarMedico(medico.id)}
                              active={medico.selecionado}>
                              <div className="d-flex align-items-center">
                                <div>
                                  <div className="fw-bold">
                                    {medico.executing_company}
                                  </div>
                                  <div
                                    className="text-muted"
                                    style={{
                                      width: "50vw",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      whiteSpace: "nowrap",
                                    }}
                                    title={medico.customer_name}>
                                    {medico.customer_name}
                                  </div>
                                  <Badge
                                    bg={
                                      coresEspecialidades[medico.especialidade]
                                    }
                                    className="rounded-pill">
                                    {medico.especialidade}
                                  </Badge>
                                </div>
                              </div>
                              <div className="d-flex align-items-center">
                                <div>
                                  valor:{" "}
                                  {formatCurrency(medico.procedure_value)}
                                </div>
                              </div>
                              <Form.Check
                                type="checkbox"
                                checked={medico.selecionado}
                                onChange={() => {}}
                                onClick={(e) => e.stopPropagation()}
                                className="fs-5"
                              />
                            </ListGroup.Item>
                          ))}
                      </ListGroup>
                    </div>

                    <div className="mt-3 d-flex justify-content-between align-items-center flex-wrap gap-2">
                      <div>
                        <small className="text-muted">
                          {medicosSelecionados.length} de{" "}
                          {
                            (medicosFiltrados || []).filter(
                              (medico) =>
                                medico &&
                                (typeof medico.fund_executing_id ===
                                  "undefined" ||
                                  medico.fund_executing_id == null)
                            ).length
                          }{" "}
                          médicos selecionados
                        </small>
                      </div>
                      <Button
                        variant="primary"
                        onClick={confirmarSelecao}
                        className="rounded-pill px-4"
                        disabled={medicosSelecionados.length === 0}>
                        <i className="bi bi-check-circle me-2"></i>
                        Confirmar Seleção
                      </Button>
                    </div>
                  </>
                ) : (
                  <div className="text-center p-4">
                    <i
                      className="bi bi-search text-muted"
                      style={{ fontSize: "3rem" }}></i>
                    <p className="lead mt-3 mb-0">
                      Nenhum médico encontrado para o período selecionado.
                    </p>
                  </div>
                )}
              </Card.Body>
            </Card>
          )}
        </Col>
      </Row>
      <footer className="my-footer-button" style={{ marginTop: "20px" }}>
        <Button
          className="btn-back"
          variant="secondary"
          onClick={() =>
            navigate("/financial/revenue-distribution-consult-emergency")
          }>
          Voltar
        </Button>
      </footer>
    </Container>
  );
  return <Menu screen={screenTela} />;
};

export default ConsultTransfer;
